import React, {Component} from 'react';
import TextField from "@material-ui/core/TextField/TextField";
import Button from "@material-ui/core/Button/Button";
import {Redirect} from "react-router-dom";

import "../../../css/pages/admin/AdminLogin.css";
import {Post} from "../../api/client/Post";

class AdminLogin extends Component {

    constructor(props) {
        super(props);

        this.state = {
            username: "admin",
            password: "",
            token: "",
            submitted: false
        };
    }

    handleChange = (event) => {
        let field = event.target.name;
        let val = event.target.value;

        this.setState({
            [field]: val
        });
    };

    submit = () => {
        Post("/api/login", {
            username: this.state.username,
            password: this.state.password
        }).then((res) => {
            let token = res.data;
            if (token !== "") {
                this.props.loginCallback(token, this.props.redirect);
            }

            this.setState({
                token: token,
                submitted: true
            });
        });
    };

    render() {
        return (
            <div id={"login-prompt"}>
                <div>
                    <h3>Admin Login</h3>
                    {
                        this.state.token === "" ?
                            (
                                <React.Fragment>
                                    <TextField
                                        label={"Username"}
                                        name={"username"}
                                        value={this.state.username}
                                        onChange={e => this.handleChange(e)}
                                        margin="normal"
                                        disabled
                                    />
                                    <br/>
                                    <TextField
                                        label={"Password"}
                                        name={"password"}
                                        value={this.state.password}
                                        onChange={e => this.handleChange(e)}
                                        margin="normal"
                                        type={"password"}
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter') {
                                                this.submit()
                                            }
                                        }}
                                    />
                                    <br/>
                                    <div style={{width: "100%"}}>
                                        <Button variant="outlined" color="primary"
                                                onClick={e => this.submit()}>
                                            LOG IN
                                        </Button>
                                    </div>
                                    {
                                        this.state.submitted ?
                                            (
                                                this.state.token === "" ?
                                                    <p>Username or password is incorrect.</p> : ""
                                            ) : ""
                                    }
                                </React.Fragment>
                            )
                            :
                            <Redirect to={"/admin/dashboard"}/>
                    }
                </div>
            </div>
        );
    }

}

export default AdminLogin;